import {DefaultChildren} from '#/utils/utils';
import {InformationCircleIcon} from '@heroicons/react/24/outline';
import {FunctionComponent} from 'react';
import {Tooltip} from 'react-tooltip';

export const InfoTriggerTooltip: FunctionComponent<
  {tooltipId: string; iconStrokeColorClassName?: `stroke-${string}`} & DefaultChildren
> = ({tooltipId, children, iconStrokeColorClassName = 'stroke-gray-400'}) => (
  <>
    <InformationCircleIcon
      className={`w-5 h-5 ${iconStrokeColorClassName} fill-transparent outline-none`}
      data-tooltip-id={tooltipId}
    />
    <Tooltip
      id={tooltipId}
      style={{
        width: '90%',
        zIndex: 50,
        borderRadius: '6px',
        backgroundColor: '#3870FF',
      }}
      render={() => <span className='text-sm font-semibold'>{children}</span>}
    />
  </>
);
